define('viewmodels/pages/cash/methods/creditCard/AddCreditCardDepositViewModel',['underscore', 'knockout', 'viewmodels/pages/cash/NameStepViewModel'], function(_, ko, NameStep) {

    function AddCreditCardDepositViewModel(player, formFields, DepositAmountStep, depositPage, depositModel, Wizard) {

        var methodModel = depositModel.methodModel(),
            wizardModel;
        
        this.wizardModel = wizardModel = new Wizard({
            steps: [
                {
                    field: formFields.textField( methodModel.cardNumber ),
                    label: depositPage.findFieldByName('credit_card_number_label'),
                    type: 'numericKeypad',
                    placeholder: ko.observable('0000000000000000')
                },
                {
                    field: formFields.dateField(
                        methodModel.expiryDate,
                        'MMYY',
                        function(date) {
                            return date ? date.endOf('month') : date;
                        }
                    ),
                    label: depositPage.findFieldByName('credit_card_expiry_date_label'),
                    type: 'numericKeypad',
                    placeholder: depositPage.findFieldByName('credit_card_expiry_date_mmyy')
                },
                new NameStep(depositPage, formFields, player.peek(), methodModel.cardHolder),
                new DepositAmountStep(depositModel),
                {
                    field: formFields.textField( methodModel.cvv ),
                    label: depositPage.findFieldByName('credit_card_cvv_label'),
                    type: 'numericKeypad',
                    placeholder: ko.observable('   ')
                }
            ],
            onPayment: function(promise) {

                return promise.then(null, function(e) {

                    // if we have any errors that can be associated with fields then invalidate them and return to that step
                    if (e.hasError('creditcard.cardnumber.invalid')) {

                        methodModel.cardNumber.invalidate('NOT_CREDIT_CARD_NUMBER');
                        wizardModel.returnToIncompleteStep();

                    } else if (e.hasError('creditcard.expiryMonth.invalid', 'creditcard.expiryYear.invalid')) {

                        methodModel.expiryDate.invalidate('NOT_CREDITCARD_EXPIRY');
                        wizardModel.returnToIncompleteStep();

                    } else if (e.hasError('creditcard.cvv.invalid')) {

                        methodModel.expiryDate.invalidate('NOT_CREDITCARD_CVV');
                        wizardModel.returnToIncompleteStep();

                    }  else {
                        throw e;
                    }

                });
            }
        });

        this.attached = function() {

            methodModel.cardNumber.isGood.subscribeAndExec(function(isGood) {
                depositModel.playerPaymentMethod().type( methodModel.getType() );
                if (isGood) {
                    depositModel.playerPaymentMethod().identifier( methodModel.getMaskedCreditCardNumber() );
                } else {
                    depositModel.playerPaymentMethod().identifier('');
                }

            });

        };

        this.detached = function() {
            methodModel.cardNumber.isGood.dispose();
        };
    }

    AddCreditCardDepositViewModel.prototype.getView = function() {
        return 'views/pages/cash/methods/wizardMethod.html';
    };

    return AddCreditCardDepositViewModel;

});

